(function () {
	function useCharacterSwiper() {
		var el = document.querySelector('#main-swiper');

		new Swiper('#main-swiper', {
			// centeredSlides: true,
			// centeredSlidesBounds: true,
			spaceBetween: 10,
			slidesPerView: 'auto',
			breakpoints: {
				1024: {
					slidesPerView: 7,
					spaceBetween: 0
				}
			},
			navigation: {
				nextEl: '.main-swiper .swiper-arrow.next',
				prevEl: '.main-swiper .swiper-arrow.prev'
			},
			on: {
				afterInit: function(param) {
					const currentBreakpoint = param.passedParams.breakpoints[param.currentBreakpoint];
					let slidesPerView = currentBreakpoint ? currentBreakpoint.slidesPerView : param.passedParams.slidesPerView;

					el.classList.toggle('justify-center', slidesPerView > param.slides.length);
				},
				resize: function(param) {
					const currentBreakpoint = param.passedParams.breakpoints[param.currentBreakpoint];
					let slidesPerView = currentBreakpoint ? currentBreakpoint.slidesPerView : param.passedParams.slidesPerView;

					el.classList.toggle('justify-center', slidesPerView > param.slides.length);
				}
			}
		});
	};

	useCharacterSwiper();

	// -----------------------------------

	function useSpecialCharacterSwiper() {
		var el = document.querySelector('#special-swiper');
		if (!el) return;

		new Swiper('#special-swiper', {
			spaceBetween: 20,
			slidesPerView: 1,
			watchOverflow: true,
			breakpoints: {
				641: {
					slidesPerView: 3,
					spaceBetween: 20
				},
				1199: {
					slidesPerView: 4,
					spaceBetween: 20
				}
			},
			navigation: {
				nextEl: '.special-characters .swiper-arrow.next',
				prevEl: '.special-characters .swiper-arrow.prev'
			},
			pagination: {
				el: '.special-characters .swiper-pagination',
				clickable: true
			},
			on: {
				afterInit: function(param) {
					const currentBreakpoint = param.passedParams.breakpoints[param.currentBreakpoint];
					let slidesPerView = currentBreakpoint ? currentBreakpoint.slidesPerView : param.passedParams.slidesPerView;

					el.classList.toggle('justify-center', slidesPerView > param.slides.length);
				},
				resize: function(param) {
					const currentBreakpoint = param.passedParams.breakpoints[param.currentBreakpoint];
					let slidesPerView = currentBreakpoint ? currentBreakpoint.slidesPerView : param.passedParams.slidesPerView;

					el.classList.toggle('justify-center', slidesPerView > param.slides.length);
				}
			}
		});
	};

	useSpecialCharacterSwiper();

	// -----------------------------------

	function useFreeReadySwiper() {
		new Swiper('#free-ready-swiper', {
			spaceBetween: 10,
			slidesPerView: 1,
			navigation: {
				nextEl: '.free-ready-swiper .swiper-arrow.next',
				prevEl: '.free-ready-swiper .swiper-arrow.prev'
			},
			pagination: {
				el: '.free-ready-swiper .swiper-pagination',
				clickable: true
			},
		});
	};

	useFreeReadySwiper();

	// -----------------------------------

	function IndexScroll() {
		var scroll_top = $(document).scrollTop();
		var s5 = scroll_top / 8;
		$('.marquee').css('transform', 'translateY(-' + s5 + 'px) scale(-1)');
	}

	$(window)
		.on('scroll', function () {
			IndexScroll();
		})
		.on('resize', function () {
			IndexScroll();
		});
})();
